<template>
  <AppShell>
    <NavCardList :cards="cards" list-class="homepage-list" />
  </AppShell>
</template>

<script setup>
/**
 * NavPage — a generic page shell for any page that is purely
 * a grid of nav cards (build_practice, transitionxart, transformation,
 * vernatics, musicxart).
 *
 * The parent entry file (e.g. build_practice_main.js) passes the card
 * array as a prop, resolved from useNavCards.js.
 */
import AppShell from '../components/AppShell.vue';
import NavCardList from '../components/NavCardList.vue';

defineProps({
  cards: { type: Array, required: true },
});
</script>
